import { useContext } from "react";
import type { UserType } from "@/types/graphql/partner";
import { AuthContext } from "../contexts/AuthContext";

interface AuthContextType {
  user: UserType;
}

export const useUser = (): AuthContextType => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error("useUser must be used within a AuthProvider");
  }

  return context;
};
